module.exports = __webpack_public_path__ + "static/media/01E.f1cbcbb9.png";